export const tableOption = {
  page: true,
  refreshBtn: false,
  columnBtn: false,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  stripe: true,
  border: true,
  viewBtn: false,
  addBtn: false, //新增按钮
  delBtn: false,
  editBtn: false,
  align: 'center',
  menuAlign: 'center',
  searchMenuSpan: 4,
  expand: true,
  searchSpan: 6,
  searchLabelWidth: 100,
  searchIcon: false,
  menuWidth: 240,
  expandRowKeys: [],
  indexWidth: 20,
  column: [
    {
      label: '轻任务订单号',
      prop: 'orderId',
      span: 24,
      width: 200,
      slot: true,
      search: true,
    },
    {
      label: '流转类型',
      prop: 'autoType',
      span: 24,
      width: 120,
      slot: true,
      type: 'select',
      search: true,
      searchSpan: 4,
      searchLabelWidth: 80,
      dicData: [
        {
          label: '手动流转',
          value: 1,
        },
        {
          label: '自动流转',
          value: 2,
        },
      ],
    },
    {
      label: '来源ID',
      prop: 'sourceId',
      search: true,
      searchSpan: 4,
      searchLabelWidth: 60,
      rules: [
        {
          required: true,
          message: '来源ID',
          trigger: 'blur',
        },
      ],
      span: 24,
      width: 180,
    },
    {
      label: '语种',
      prop: 'lan',
      span: 24,
      width: 150,
    },
    {
      label: '状态',
      prop: 'status',
      type: 'select',
      search: true,
      searchSpan: 3,
      searchLabelWidth: 50,
      dicData: [
        {
          label: '进行中',
          value: 1,
        },
        {
          label: '已提交',
          value: 2,
        },
      ],
      slot: true,
      span: 24,
      width: 80,
    },
    {
      label: '当前总成本',
      prop: 'amount',
      search: false,
      span: 24,
      width: 100,
    },
    {
      width: 100,
      label: '领域',
      prop: 'fieldName',
      search: true,
      slot: true,
      searchslot: true,
      span: 24,
      searchSpan: 3,
      searchLabelWidth: 50,
    },
    {
      label: '步骤',
      prop: 'step',
      slot: true,
      span: 24,
      width: 200,
    },
    {
      label: '创建时间',
      prop: 'createTime',
      slot: true,
      span: 24,
    },
  ],
};

export const termTableOption = {
  page: true,
  refreshBtn: false,
  columnBtn: false,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  stripe: true,
  border: true,
  viewBtn: false,
  addBtn: false, //新增按钮
  delBtn: false,
  editBtn: false,
  align: 'center',
  menuAlign: 'center',
  // expand: true,
  menu: false, // 操作列
  // searchSpan: 6,
  // searchIcon: false,
  index: true,
  indexLabel: '序号',
  column: [
    {
      label: '原文',
      prop: 'srcText',
      span: 24,
      // width: 200,
    },
    {
      label: '译文',
      prop: 'tranText',
      span: 24,
      // width: 180,
    },
    {
      label: '创建者昵称',
      prop: 'createUserName',
      span: 24,
      // width: 150,
    },
    {
      label: '采纳状态',
      prop: 'checkStatus',
      type: 'select',
      dicData: [
        {
          label: '待处理',
          value: 1,
        },
        {
          label: '采纳',
          value: 2,
        },
        {
          label: '未采纳',
          value: 3,
        },
      ],
      span: 24,
      // width: 80
    },
    {
      label: '金额',
      prop: 'amt',
      span: 24,
      // width: 100,
    },
    {
      label: '创建时间',
      prop: 'createTime',
      slot: true,
      span: 24,
    },
  ],
};

export const sentOption = {
  card: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: true,
  menu: false,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  border: true,
  editBtn: false,
  column: [
    {
      label: '原文',
      prop: 'srcText',
      slot: true,
    },
    {
      label: '机翻译文',
      prop: 'mtText',
      slot: true,
    },
    {
      label: '译文',
      prop: 'peText',
      slot: true,
    },
    {
      label: '质控',
      prop: 'qcId',
    },
  ],
};
